export default "__VITE_ASSET__CnXLRbJs__"